export default __webpack_public_path__ + "static/media/register7.a33b9fc8.jpg";